<template>
    <div>
        <vue-headful :title="'Designation :: MeritEHS'"/>

        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/subcontractors`">
                            <i class="fa fa-id-badge"></i> Subcontractors
                        </router-link>
                    </li>
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/subcontractors/settings#prequalification`">
                            Settings - Designations
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active">
                        <template v-if="designation_id"><i class="fa fa-edit"></i> Edit</template>
                        <template v-else><i class="fa fa-plus"></i> Add</template>
                    </li>
                </ol>
            </h4>

            <div class="row mb-4">
                <div class="col-md-8">
                    <div class="card">
                        <div class="card-body">
                            <div class="row form-group">
                                <label class="col-md-3 col-sm-4 col-form-label text-sm-right" :class="{'text-danger': errors.designation_name}">Designation Name:</label>
                                <div class="col-md-6 col-sm-8">
                                    <input type="text" name="designation_name" v-model="designation.designation_name" :class="{'form-control': true, 'is-invalid': errors.designation_name}" placeholder="Enter Designation Name" />
                                    <span v-if="errors.designation_name" class="text-danger">
                                        <span v-for="error in errors.designation_name">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <button type="button" class="btn btn-success" v-on:click="saveDesignation(this)" :disabled="saving">
                Save Designation
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                loading: true,
                saving: false,
                designation_id: this.$route.params.id,
                designation: {},
                errors: {},
            }
        },

        methods: {
            getErrorClass: function(attribute) {
                return {
                    'form-group has-error': this.errors[attribute],
                    'form-group': !this.errors[attribute],
                }
            },

            getDesignation() {
                //Get the data
                this.$http
                    .get('subcontractors/designations-edit' + (this.designation_id ? '/' + this.designation_id : ''))
                    .then(response => {
                        //Set all the data
                        this.designation = response.data;

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });
            },

            saveDesignation() {
                //Show loading
                this.saving = true;

                //Reset the errors
                this.errors = {};

                //Send it
                this.$http
                .post('subcontractors/designations-edit' + (this.designation_id ? '/' + this.designation_id : ''), this.designation)
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('Designation Saved');

                    //Return to main list?
                    this.$router.push('/subcontractors/settings#designations');
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data
                    }
                })
                .then(response => {
                    //Show loading
                    this.saving = false;
                });
            }
        },

        mounted() {
            //Get the incidents
            this.getDesignation();
        }
    }
</script>
